<template>
  <div class>
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Bảng điều khiển', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <!--Charts-->
    <div class="container-fluid mt--6 bg-lighter">
      <block>
        <b-row class="my-6" align-h="center">
          <b-col md="4">
            <router-link
              v-if="this.$permission('user_list')"
              :to="{ name: 'user-manage' }"
              class="btn btn-light btn-block py-6 mb-5"
            >
              <template>
                <i class="ni ni-single-02 text-light"></i>
                <span class="nav-link-text">Quản lý nhân viên</span>
              </template>
            </router-link>
          </b-col>
          <b-col md="4">
            <router-link
              v-if="this.$permission('customer_list')"
              :to="{ name: 'customer-manage' }"
              class="btn btn-info btn-block py-6 mb-5"
            >
              <template>
                <i class="ni ni-badge text-light"></i>
                <span class="nav-link-text">Quản lý khách hàng</span>
              </template>
            </router-link>
          </b-col>
          <b-col md="4">
            <router-link
              v-if="this.$permission('product_list')"
              :to="{ name: 'product-manage' }"
              class="btn btn-dark btn-block py-6 mb-5"
            >
              <template>
                <i class="ni ni-shop text-light"></i>
                <span class="nav-link-text">Quản lý sản phẩm</span>
              </template>
            </router-link>
          </b-col>
          <b-col md="4">
            <router-link
              v-if="this.$permission('quota_list')"
              :to="{ name: 'quotation-manage' }"
              class="btn btn-secondary btn-block py-6 mb-5"
            >
              <template>
                <i class="fa fa-clipboard-list text-light"></i>
                <span class="nav-link-text">Quản lý báo giá</span>
              </template>
            </router-link>
          </b-col>
          <b-col md="4">
            <router-link
              v-if="this.$permission('order_list')"
              :to="{ name: 'order-manage' }"
              class="btn btn-success btn-block py-6 mb-5"
            >
              <template>
                <i class="fa fa-chart-line text-light"></i>
                <span class="nav-link-text">Quản lý đơn hàng</span>
              </template>
            </router-link>
          </b-col>
          <b-col md="4">
            <router-link
              v-if="this.$permission('manufacture_list')"
              :to="{ name: 'manufacture-manage' }"
              class="btn btn-warning btn-block py-6 mb-5"
            >
              <template>
                <i class="ni ni-building text-light"></i>
                <span class="nav-link-text">Quản lý lệnh chế tạo</span>
              </template>
            </router-link>
          </b-col>
          <b-col md="4">
            <router-link
              v-if="this.$permission('receipt-bill_report')"
              :to="{ name: 'warehouse-manage' }"
              class="btn btn-primary btn-block py-6 mb-5"
            >
              <template>
                <i class="ni ni-money-coins text-light"></i>
                <span class="nav-link-text">Quản lý nhập xuất</span>
              </template>
            </router-link>
          </b-col>
          <b-col md="4">
            <router-link
              v-if="this.$permission('receipt-bill_debt')"
              :to="{ name: 'debt-manage' }"
              class="btn btn-danger btn-block py-6 mb-5"
            >
              <template>
                <i class="fa fa-calculator text-light"></i>
                <span class="nav-link-text">Quản lý công nợ</span>
              </template>
            </router-link>
          </b-col>
          <b-col md="4">
            <router-link
              v-if="this.$permission('receipt-bill_verify-in')"
              :to="{ name: 'scanner-tem' }"
              class="btn btn-info btn-block py-6 mb-5"
            >
              <template>
                <i class="fa fa-calculator text-light"></i>
                <span class="nav-link-text">Quét nhập kho</span>
              </template>
            </router-link>
          </b-col>
        </b-row>
      </block>
    </div>
  </div>
</template>
<script>
export default {
  name: "dashboard",
  meta: {
    title: "Home Page",
    auth: true
  },
  data() {
    return {
      allMenus: [
        {
          label: "Quản lý Sản phẩm",
          icon: "ni ni-shop text-danger",
          name: "product-manage",
          rule: "product_list",
          childs: []
        },
        {
          label: "Lệnh chế tạo",
          icon: "ni ni-building text-info",
          name: "manufacture-manage",
          rule: "manufacture_list",
          childs: []
        },
        {
          label: "Nhập xuất kho",
          icon: "ni ni-money-coins text-primary",
          name: "warehouse-manage",
          rule: "receipt-bill_report",
          childs: []
        },
        {
          label: "Quản lý công nợ",
          icon: "fa fa-calculator text-primary",
          name: "debt-manage",
          rule: "receipt-bill_debt",
          childs: []
        },
        {
          label: "Báo giá đã tạo",
          icon: "fa fa-clipboard-list text-info",
          name: "quotation-manage",
          rule: "quota_list",
          childs: []
        },
        {
          label: "Quản lý Đơn hàng",
          icon: "fa fa-chart-line text-primary",
          name: "order-manage",
          id: "navbar-order",
          rule: "order_list",
          childs: [
            {
              label: "Đơn hàng đã tạo",
              icon: "fa fa-clipboard-list text-info",
              name: "order-manage",
              rule: "order_list"
            },
            {
              label: "Tạo mới",
              icon: "fa fa-code-branch text-gray",
              name: "add-order",
              rule: "order_create"
            }
          ]
        },
        {
          label: "Cài đặt",
          icon: "ni ni-settings text-red",
          id: "navbar-role",
          childs: [
            {
              label: "Phân quyền",
              icon: "ni ni-lock-circle-open text-gray",
              name: "role-manage",
              rule: "role_list"
            },
            {
              label: "Cấu hình",
              icon: "ni ni-email-83 text-gray",
              name: "config",
              rule: "config_list"
            }
          ]
        }
      ],
      menus: []
    };
  },
  methods: {
    validatePermissionMenu() {
      this.allMenus.forEach(menu => {
        if (menu.childs.length > 0) {
          let submenu_exists = false;
          let menuGroup = Object.assign({}, menu);
          menuGroup.childs = [];
          for (let i = 0; i < menu.childs.length; i++) {
            const item = menu.childs[i];
            if (this.$permission(item.rule)) {
              submenu_exists = true;
              menuGroup.childs.push(item);
            }
          }
          if (submenu_exists) {
            this.menus.push(menuGroup);
          }
        } else {
          if (this.$permission(menu.rule)) {
            this.menus.push(menu);
          }
        }
      });
    }
  },
  mounted() {
    this.validatePermissionMenu();
  }
};
</script>
<style></style>
